'use strict';

import template from './info_terms_and_conditions_giveaway.html';

const saInfoTermsAndConditionsGiveaway = function () {
  return {
    template: template,
    replace: true,
    scope: {},
    bindToController: true,
    controllerAs: 'ctrl',
    controller: [function () {}]
  };
};

export default saInfoTermsAndConditionsGiveaway;



// WEBPACK FOOTER //
// ./app/src/modules/info/info_terms_and_conditions_giveaway.component.js